import { getElementName } from "backend/element";
import { ICardElementWithChildren } from "backend/model/model";
import { t } from "i18next";
import React from "react";
import Todo from "../misc/Todo";

import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import KPIIcon from "assets/KPIIcon";
import InitativeIcon from "assets/InitiativeIcon";

const useHeaderStyles = makeThemedStyles("HeaderStyles", (theme) => ({
  measurementHeader: {
    fontSize: "12px",
    flexBasis: "100%",
    display: "inline-flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
    flexWrap: "nowrap",
  },
}));

export const MeasurementHeader = (props: {
  typename: string;
  title: string;
}) => {
  return (
    <div>
      <Todo>Make this Icon</Todo>
      <div>{props.typename}</div>
      <div>{t(props.title)}</div>
    </div>
  );
};
export const KpisHeader = (props: { icon?: string; header: string }) => {
  const classes = useHeaderStyles();
  return (
    <div className={classes.measurementHeader}>
      <div>
        <KPIIcon size={20} />
      </div>
      <div>{props.header}</div>
    </div>
  );
};

export const InitiativesHeader = (props: { icon?: string; header: string }) => {
  const classes = useHeaderStyles();
  return (
    <div className={classes.measurementHeader}>
      <div>
        <InitativeIcon size={20} />
      </div>
      <div>{props.header}</div>
    </div>
  );
};

export const StrategyCardHeader = (props: { title: string }) => {
  return <div>{props.title}</div>;
};
